export default __webpack_public_path__ + "static/imgGAP-7c14b5fed31836787a8f059f61e1bd7e.webp";